import { buildTranslate } from 'locales'

const t = buildTranslate('thanx_campaigns.review.segment_state')

// Currently only handles the 'requires_approval' state, similar to SegmentStateBadge
const SegmentStateBanner = () => {
  return (
    <div
      className="p-l mb-l mt-l"
      style={{ backgroundColor: '#FAF0D1' }}
      data-testid="segment-state-banner"
    >
      <p className="mb-0 font-size-14 grey-70">{t('requires_approval')}</p>
    </div>
  )
}

export default SegmentStateBanner
